import React from "react";
import { Outlet } from "react-router-dom";

const AuthLayout = () => {
  return (
    <main className="lms-main-section">
      <div className="lms-container">
        <Outlet />
      </div>
    </main>
  );
};

export default AuthLayout;
